import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { disconnectWS } from "../lib/chatws";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("vault_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("vault_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (token) => {
    localStorage.setItem("vault_token", token);
    const res = await api.get("/auth/me");
    setUser(res.data);
    return res.data;
  };

  const updateUser = (u) => setUser(u);

  const refresh = async () => {
    const res = await api.get("/auth/me");
    setUser(res.data);
    return res.data;
  };

  const logout = () => {
    disconnectWS();
    localStorage.removeItem("vault_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, updateUser, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
